import { createContext, useContext } from 'react';

// What the app shell (layouts/AppLayout.jsx) lets a page do: open "New" (the one input
// and the create tiles; in a project with it filled in) and the search. Home's composer
// card on phones and its Search button use it.
export const ShellActionsContext = createContext({ openNew: () => {}, openSearch: () => {} });

export const useShellActions = () => useContext(ShellActionsContext);
